<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div
            class="Polaris-Box Polaris-Box--printHidden"
            style="display: flex; align-items: center"
          >
            <button
              class="Polaris-Button Polaris-Button--primary"
              @click="gotoLanguageSettings"
              style="margin-left: 0"
            >
              Change Language
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="my-2">
          <div class="overview-wrapper-cont">
            <OnboardingChecklist class="my-4" />
            <WidgetInstaller
              v-if="shouldShowWidgetInstaller(config)"
            ></WidgetInstaller>
            <div>
              <h3 class="text-base leading-6 font-medium text-gray-900 my-2">
                Select Date
              </h3>
              <DateRangePicker
                v-model="currentConfig"
                opens="right"
                :ranges="ranges"
                @update="dateSelected"
              />
              <div v-if="isLoading">
                <Spinner />
              </div>
              <h3 class="text-lg leading-6 font-medium text-gray-900 mt-4">
                {{ dateDiff }}
              </h3>
              <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
                Abandoned carts
              </h3>
              <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                          />
                        </svg>

                        Messages sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{
                          automationReport.abandonedCartMessagesSent > 0
                            ? automationReport.abandonedCartMessagesSent
                            : checkoutReport.totalMessagesSent
                        }}
                      </dd>
                    </dl>
                  </div>
                </div>

                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                          />
                        </svg>

                        Carts recovered
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ checkoutReport.cartsRecovered }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                          />
                        </svg>

                        Cart value recovered
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ recoveredValue }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
                Chat & share
              </h3>
              <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                          />
                        </svg>

                        Chat clicked
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ chatReport.chatClicks }}
                      </dd>
                    </dl>
                  </div>
                </div>

                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                          />
                        </svg>

                        Share Clicked
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ chatReport.shareClicks }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <h3 class="text-lg leading-6 font-medium text-gray-900 mt-5">
                Automation
              </h3>
              <div class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
                          />
                        </svg>
                        Abandoned messages sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ automationReport.abandonedCartMessagesSent || 0 }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        Order confirmation messages sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{
                          automationReport.orderConfirmationMessagesSent || 0
                        }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
                          />
                        </svg>
                        Order shipping updates sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ automationReport.orderShippingUpdatesSent || 0 }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
                          />
                        </svg>
                        COD messages sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ automationReport.codConfirmationMessagesSent || 0 }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="bg-white overflow-hidden shadow rounded-lg">
                  <div class="px-4 py-5 sm:p-6">
                    <dl>
                      <dt
                        class="text-sm leading-5 font-medium text-gray-500 flex"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="w-6 h-6 mr-2"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
                          />
                        </svg>
                        Review requests sent
                      </dt>
                      <dd
                        class="mt-1 text-3xl leading-9 font-semibold text-gray-900"
                      >
                        {{ automationReport.reviewRequestsSent || 0 }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>

              <div class="Polaris-LegacyCard mt-4">
                <div class="Polaris-MediaCard">
                  <div class="Polaris-MediaCard__MediaContainer">
                    <img
                      alt=""
                      width="100%"
                      height="100%"
                      style="
                        object-fit: cover;
                        object-position: center;
                        aspect-ratio: 19 / 13;
                      "
                      src="https://cdn.shopify.com/app-store/listing_images/8fc5f6d4d41f33cfcf0ebc61d01b572a/icon/CN2aot70lu8CEAE=.png"
                    />
                  </div>
                  <div class="Polaris-MediaCard__InfoContainer">
                    <div
                      class="Polaris-Box"
                      style="
                        --pc-box-padding-block-start-xs: var(--p-space-500);
                        --pc-box-padding-block-end-xs: var(--p-space-500);
                        --pc-box-padding-inline-start-xs: var(--p-space-500);
                        --pc-box-padding-inline-end-xs: var(--p-space-500);
                      "
                    >
                      <div
                        class="Polaris-BlockStack"
                        style="
                          --pc-block-stack-order: column;
                          --pc-block-stack-gap-xs: var(--p-space-200);
                        "
                      >
                        <div
                          class="Polaris-InlineStack"
                          style="
                            --pc-inline-stack-align: space-between;
                            --pc-inline-stack-wrap: nowrap;
                            --pc-inline-stack-gap-xs: var(--p-space-200);
                            --pc-inline-stack-flex-direction-xs: row;
                          "
                        >
                          <div>
                            <h2
                              class="Polaris-Text--root Polaris-Text--headingSm"
                            >
                              Automated abandoned cart recovery
                            </h2>
                          </div>
                          <div
                            class="Polaris-Box"
                            style="
                              position: absolute;
                              --pc-box-inset-inline-end: var(--p-space-500);
                              z-index: var(--p-z-index-2);
                            "
                          >
                            <div
                              class="Polaris-InlineStack"
                              style="
                                --pc-inline-stack-wrap: nowrap;
                                --pc-inline-stack-gap-xs: var(--p-space-100);
                                --pc-inline-stack-flex-direction-xs: row;
                              "
                            >
                              <div>
                                <div
                                  class="Polaris-InlineStack"
                                  style="
                                    --pc-inline-stack-block-align: center;
                                    --pc-inline-stack-wrap: wrap;
                                    --pc-inline-stack-flex-direction-xs: row;
                                  "
                                >
                                  <!-- Action button can be added here if needed -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <p class="Polaris-Text--root Polaris-Text--bodySm">
                          Send reminders to abandoned checkouts on WhatsApp to
                          convert more orders
                        </p>
                        <div class="Polaris-MediaCard__ActionContainer">
                          <div class="Polaris-ButtonGroup">
                            <div class="Polaris-ButtonGroup__Item">
                              <div>
                                <button
                                  class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                                  type="button"
                                  @click="gotoAutomation"
                                >
                                  <span
                                    class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                    >Setup Automation</span
                                  >
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";

import OnboardingChecklist from "../components/Onboarding/OnboardingChecklist.vue";

import Spinner from "vue-simple-spinner";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import WidgetInstaller from "../components/Chat/WidgetInstaller";

// import ReviewUs from "../components/Common/ReviewUs";

import {
  subDays,
  format,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth
} from "date-fns";

export default {
  name: "Analytics",
  components: {
    Page,
    DateRangePicker,
    Spinner,
    WidgetInstaller,
    // ReviewUs,
    OnboardingChecklist
  },
  data() {
    return {
      pageTitle: "Overview",
      report: {},
      chatReport: {},
      checkoutReport: {},
      automationReport: {},
      currencyFormat: "",
      urlReport: {},
      clickedCount: {},
      currentConfig: {
        startDate: "",
        endDate: ""
      },
      ranges: {},
      isLoading: false
    };
  },
  computed: {
    dateDiff() {
      const startDate = this.currentConfig.startDate;
      const endDate = this.currentConfig.endDate;

      if (startDate && endDate) {
        return `${format(startDate, "dd MMM yyyy")} - ${format(
          endDate,
          "dd MMM yyyy"
        )}`;
      }
      return "";
    },
    config() {
      return this.$store.getters.getConfig;
    },
    recoveredValue() {
      const value = this.currencyFormat.replace(
        "{{amount}}",
        this.checkoutReport.cartsRecoveredValue
      );
      return value;
    }
  },
  async created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);
    this.ranges = {
      Today: [today, today],
      Yesterday: [yesterday, yesterday],
      "This month": [startOfMonth(today), endOfMonth(today)],

      "Last month": [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0)
      ]
    };
  },
  mounted() {
    const startDate = subDays(new Date(), 7);
    this.currentConfig = {
      startDate: startDate,
      endDate: new Date()
    };
    this.getReport();
  },
  methods: {
    dateSelected() {
      this.getReport();
    },
    async getReport() {
      this.isLoading = true;
      const startDate =
        startOfDay(this.currentConfig.startDate).getTime() / 1000;
      const endDate = endOfDay(this.currentConfig.endDate).getTime() / 1000;
      const response = await this.$store.dispatch("getAnalytics", {
        startDate,
        endDate
      });
      this.report = response;
      this.chatReport = response.chatReport;
      this.checkoutReport = response.checkoutReport;
      this.automationReport = response.automationReport;
      this.currencyFormat = response.currencyFormat;
      this.urlReport = response.urlReport;
      this.isLoading = false;
    },
    gotoAutomation() {
      if (window.appBridgeApp) {
        history.pushState({}, null, "/automation");
        this.$router.push({ path: "/automation" });
      } else {
        this.$router.push({ name: "FullyAutomated" });
      }
    },
    shouldShowWidgetInstaller(config) {
      if (config && config.createdAt > 1747381243) {
        return true;
      }
      return false;
    },
    gotoLanguageSettings() {
      this.$router.push({ name: "Language" });
    }
  }
};
</script>

<style lang="scss">
.input-date {
  border-radius: 4px;
  font-size: 13px !important;
  font-family: inter;
  font-weight: 400;
}

.daterangepicker .calendars {
  display: flex;
}

.reportrange-text {
  border-radius: 4px;
}

.overview-wrapper-cont {
  display: flex;
  flex-direction: column;
}
</style>
